import React from "react";
import { getUiOptions, } from "@rjsf/utils";
export default function TitleField({ id, title, uiSchema }) {
    const uiOptions = getUiOptions(uiSchema);
    return (React.createElement("h5", { id: id, className: "mt-0 mb-4 text-lg font-medium leading-tight" }, uiOptions.title || title));
}
//# sourceMappingURL=TitleField.js.map